<template>
  <div class="slogan">
    <div class="content-center">
      <div class="title">
        <span>易隆创始终致力于以技术创新为核心驱动，</span>
        <span>&emsp;&emsp;&emsp;&emsp;&emsp;通过跨组织高效协同，实现客户、伙伴与企业的共赢发展。</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
};
</script>

<style lang="less" scoped>
.slogan {
  height: 302px;
  background-image: url('@/assets/img/home/Slogan/background.png');
  background-size: cover;
  background-position: center;

  .content-center {
    display: flex;
    justify-items: center;
    align-items: center;

    .title {
      font-family: @font-bold;
      font-size: 32px;
      line-height: 74px;
      letter-spacing: 1px;
      color: transparent;
      background: linear-gradient(to right, #DEAC6B 0%, #F6EAD7 40%, #DCAE6A 100%);
      background-clip: text;

      span {
        text-indent: 114px;
        display: inline-block;
      }
    }
  }
}
</style>
